// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import { UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { ContentBlock } from "@/components/wpl/content-block/src";
import { Link } from "@/components/wpl/link/src";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const CTASection = () => {
    const intl = useIntl();

    const linkDataEventProps: DataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware"
    };

    return (
        <section
            css={css`
                align-items: center;
                background-color: #091e42;
                color: #ffffff;
                display: flex;
                flex-direction: column;
                gap: 24px;
                padding: 32px 0;

                h2 {
                    font-size: 2.25rem;
                }

                ${UNSAFE_media.below.sm} {
                    h2 {
                        font-size: 1.5rem;
                    }
                }

                .features-link {
                    svg {
                        transition: transform 0.25s ease-in-out;

                        path {
                            fill: #fafbfc;
                        }
                    }

                    &:focus,
                    &:visited,
                    &:hover {
                        color: #fafbfc;
                    }

                    &:hover {
                        text-decoration: underline;

                        svg {
                            transform: translateX(${token("space.100")});
                        }
                    }
                }
            `}
        >
            <ContentBlock
                headerType="h2"
                headerText={intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.ctaSection.getStarted",
                    defaultMessage: "Get Started with Jira Software"
                })}
                orientation="vertical"
                ctaProps={{
                    buttonProps: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePageTemplate.ctaSection.getItFree",
                            defaultMessage: "Get it free"
                        }),
                        color: "yellow",
                        url: useLocalizedHref("/software/jira/free"),
                        dataEventProps: linkDataEventProps
                    }
                }}
                isCentered
            />
            <Link
                className="features-link"
                href={useLocalizedHref("/software/jira/features")}
                text={intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.ctaSection.seeFeatures",
                    defaultMessage: "See features"
                })}
                bgColor="bgDark"
                dataEventProps={linkDataEventProps}
            />
        </section>
    );
};

export default CTASection;
